export const TIER_COLORS = {
  0: '#4caf50', // Pass — green
  1: '#ff9800', // Suspicious — orange
  2: '#f44336', // Likely IVT — red
  3: '#9c27b0', // Confirmed IVT — purple
};

export const TIER_LABELS = {
  0: 'Pass',
  1: 'Suspicious',
  2: 'Likely IVT',
  3: 'Confirmed IVT',
};

const RISK_THRESHOLDS = { HIGH: 50, MEDIUM: 20 };
const IVT_RATE_THRESHOLD = 10;

export const COLORS = {
  RED: '#f44336',
  ORANGE: '#ff9800',
  GREEN: '#4caf50',
  GREY: '#9e9e9e',
};

export function getRiskScoreColor (score) {
  if (score > RISK_THRESHOLDS.HIGH) return COLORS.RED;
  if (score > RISK_THRESHOLDS.MEDIUM) return COLORS.ORANGE;
  return COLORS.GREEN;
}

export function getIvtRateColor (rate) {
  return rate > IVT_RATE_THRESHOLD ? COLORS.RED : COLORS.GREEN;
}
